/**
 * PROPOSITION-BOOLEAN-REPARTITION
 * Non / Oui / Non concerné pills for one battery item (question.options.multipleItems)
 */

import { connect } from "react-redux"
import { WithTranslation, withTranslation } from "react-i18next"
import { Session } from "@/redux/_session.types"
import Chip from "./chip"

interface StateProps {
  _session: Session
}

interface OwnProps {
  repartition: number[] //[countNon, countOui]
  noAnswers: number
}

type Props = StateProps & OwnProps & WithTranslation

function PropositionBooleanRepartition(props: Props) {
  const { t } = props

  const countNon = props.repartition[0] ?? 0
  const countOui = props.repartition[1] ?? 0
  const hasResults = countNon + countOui + props.noAnswers > 0

  //Each chip is its own grid cell (parent grid has one column per color) so same-color chips share a column width and line up
  return hasResults ? (
    <>
      <Chip color="#8c8c8c" count={countNon}>
        {t("utils_no")}
      </Chip>
      <Chip color="#20ca7e" count={countOui}>
        {t("utils_yes")}
      </Chip>
      <Chip color="#c7c7c7" count={props.noAnswers}>
        {t("question_not_concerned_dashboard")}
      </Chip>
    </>
  ) : (
    <p className="grey-t" style={{ margin: 0, gridColumn: "2 / -1" }}>
      <b>{t("questions_no_results", { count: props._session.participationMin })}</b>
    </p>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(withTranslation()(PropositionBooleanRepartition))
